import React from 'react';
import { Link } from 'react-router-dom';
import { translations } from '../data/translations';
import { MapPin, Mail } from 'lucide-react';
import ContactForm from './ContactForm';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_4a49ee36-674e-4876-bdde-a21aaf32773b/artifacts/4ka36pr5_Logo%20Samanext%20Transparente.png';

const Footer = ({ lang }) => {
  const t = translations[lang].footer;
  
  return (
    <footer id="contact" className="bg-black border-t border-white/25 py-16">
      <div className="max-w-5xl mx-auto px-6 lg:px-16">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Left Column - Contact Form */}
          <div>
            <ContactForm lang={lang} />
          </div>
          
          {/* Right Column - Company Info */}
          <div className="md:text-right">
            <Link to="/" className="inline-block hover:opacity-80 transition-opacity duration-300 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Samanext Technologies" 
                className="h-10 w-auto md:ml-auto"
              />
            </Link>
            <p className="text-white/60 text-base leading-relaxed max-w-md md:ml-auto mb-6">
              {t.tagline}
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center gap-3 md:justify-end text-white/60">
                <MapPin className="w-4 h-4 text-[#00FFD1]" />
                <span className="text-base">{t.location}</span>
              </div>
              
              <div className="flex items-center gap-3 md:justify-end">
                <Mail className="w-4 h-4 text-[#00FFD1]" />
                <a 
                  href={`mailto:${t.email}`}
                  className="text-base text-white/60 hover:text-[#00FFD1] transition-colors duration-300"
                >
                  {t.email}
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Divider */}
        <div className="w-full h-[1px] bg-white/25 mb-8" />
        
        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            {t.copyright}
          </p>
          
          <div className="flex items-center gap-6">
            <Link 
              to="/eqtos" 
              className="text-[#00FFD1] text-sm hover:underline"
            >
              EQTOS
            </Link>
            <a 
              href="https://eqtos.tech" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/40 text-sm hover:text-white transition-colors"
            >
              eqtos.tech
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
